import { render } from "./FeedBackModal.vue?vue&type=template&id=72bb6759&scoped=true"
import script from "./FeedBackModal.vue?vue&type=script&lang=js"
export * from "./FeedBackModal.vue?vue&type=script&lang=js"

import "./FeedBackModal.vue?vue&type=style&index=0&id=72bb6759&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72bb6759"]])

export default __exports__